import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import salesStore from './sales'
import loadingStore from './loading'
import contractStore from './contract'
import routeStore from './route'

// Definição do modulos
Vue.use(Vuex);

// const vuexLocal = new VuexPersistence({
//   storage: window.sessionStorage,
//   saveState:(key,state,storage)=>{
//       storage.setItem(key, JSON.stringify(state));
//   },
//   restoreState:(key,storage)=>{
//     return JSON.parse(storage.getItem(key));
//   },
//   filter:(mutation)=>{
//     //Trigger que é disparada para salvar a store de acordo com o type da mutação
//   }
// });



const store = new Vuex.Store({
  modules:{
    sales : salesStore,
    loading: loadingStore,
    contract: contractStore,
    route: routeStore
  },
 // plugins:  [vuexLocal.plugin]
});

export default store;





// WEBPACK FOOTER //
// ./src/store/index.js